import React from "react";
import { Button } from "react-bootstrap";
import { bindActionCreators, } from "redux";
import { connect } from "react-redux";
import { Form } from 'react-redux-form';
// Domain
import * as authDomain from "user/authentication/Authentication";
// Actions \ Action Creators
import * as authenticationActions from "user/authentication/actions";
//-- Domain UI --------------------------------------------------------------------------------------
// Components
import { FormServerError } from "common/ui/components/forms/FormServerError";
import { TextBox } from "common/ui/components/inputs/TextBox";
//-- Helpers --------------------------------------------------------------------------------------
// Form Helpers
import * as formHelpers from "common/utils/formHelpers";
import validator from 'validator';
const mapStateToProps = (state) => {
    return {
        resetPassword: state.authenticationForms.resetPassword,
        resetPasswordForm: state.authenticationForms.resetPasswordForm
    };
};
const mapDispatchToProps = (dispatch) => ({
    authenticationActions: bindActionCreators(authenticationActions, dispatch),
    dispatch: dispatch
});
class ForgotPasswordResetForm extends React.Component {
    componentWillMount() {
        // Initialise the phone number if it exists
        if (this.props.resetPassword && this.props.resetPassword.mobile) {
            this.props.authenticationActions.initialiseResetMobile(this.props.resetPassword.mobile);
        }
    }
    //---------------------------------------------------------------------
    handleSubmit(form) {
        // Initialise local variables
        const { authenticationActions } = this.props;
        // Create Dto
        let dto = {
            mobile: form.mobile,
            code: form.code,
            password: form.newPassword
        };
        // Submit to server
        authenticationActions.forgotPasswordResetFromOtp(dto);
    }
    //---------------------------------------------------------------------
    comparePasswords(passwordA, passwordB) {
        return passwordA === passwordB;
    }
    render() {
        let { resetPasswordForm, resetPassword } = this.props;
        return (React.createElement(Form, { model: authDomain.pathsResetPassword.modelPath, onSubmit: (form) => this.handleSubmit(form) },
            React.createElement(TextBox, { model: authDomain.pathsResetPassword.code, form: this.props.resetPasswordForm, labelText: "One-time pin code (OTP)", errors: {
                    required: "OTP code is required"
                }, placeHolderText: "Enter code", validators: { required: formHelpers.isRequired } }),
            React.createElement(TextBox, { model: authDomain.pathsResetPassword.mobile, form: this.props.resetPasswordForm, labelText: "Mobile number", errors: {
                    required: "Mobile number is required",
                    validMobile: "Mobile number is not valid"
                }, placeHolderText: "Enter mobile number", validators: {
                    required: formHelpers.isRequired,
                    validMobile: (val) => validator.isMobilePhone(val, 'en-ZA')
                } }),
            React.createElement(TextBox, { model: authDomain.pathsResetPassword.newPassword, form: this.props.resetPasswordForm, type: "password", labelText: "Password", errors: {
                    required: "Password is required",
                    length: "Password must be at least 6 characters long"
                }, placeHolderText: "Enter password", onChangeCallback: (newValue) => this.comparePasswords(newValue, resetPassword.newPasswordConfirm), validators: {
                    required: formHelpers.isRequired,
                    length: (val) => val.length >= 6
                } }),
            React.createElement(TextBox, { model: authDomain.pathsResetPassword.newPasswordConfirm, form: this.props.resetPasswordForm, type: "password", labelText: "Confirm Password", errors: { matches: "Passwords don't match" }, placeHolderText: "Confirm password", validators: { matches: (val) => val === resetPassword.newPassword } }),
            React.createElement(FormServerError, { form: resetPasswordForm.$form }),
            React.createElement(Button, { type: "submit", bsStyle: "success", disabled: resetPasswordForm.$form.pending || !resetPasswordForm.$form.valid }, resetPasswordForm.$form.pending ? 'Submitting...' : 'Finish')));
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordResetForm);
